import DeleteSiHaDocumentationRequestModelBase from '../_generated/modelBases/delete-si-ha-documentation-request-model-base';

export default class DeleteSiHaDocumentationRequestModel extends DeleteSiHaDocumentationRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
